import { render, staticRenderFns } from "./LastAdviceList.vue?vue&type=template&id=7d070c18&scoped=true&"
import script from "./LastAdviceList.vue?vue&type=script&lang=js&"
export * from "./LastAdviceList.vue?vue&type=script&lang=js&"
import style0 from "./LastAdviceList.vue?vue&type=style&index=0&id=7d070c18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d070c18",
  null
  
)

export default component.exports